/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDirectDebitPreferencesRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/direct_debit_preferences.pb'
import {GetDirectDebitPreferencesResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/direct_debit_preferences.pb'


export const getDirectDebitPreferences = (request: GetDirectDebitPreferencesRequest, options?: CashRequestOptions) => post<GetDirectDebitPreferencesRequest, GetDirectDebitPreferencesResponse>("/2.0/cash/get-direct-debit-preferences", request, {...options, rejectOnError: true })